import { Helmet } from "react-helmet-async"
import { TVisa, VisaServiceTypes } from "../../../../Visa"
import { useOutletContext } from "react-router"

export default function VisaServiceTypesDetailsPage() {
	const { service, onSuccess } = useOutletContext<{ service: TVisa, onSuccess: () => void }>()
	return (
		<>
			<Helmet>
				<title>Visa Service Types</title>
			</Helmet>
			<VisaServiceTypes service={service} onSuccess={onSuccess} />
		</>
	)
}
